module.exports = __webpack_public_path__ + "static/media/bfile-no.9c9de24c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-no.svg
// module id = 259
// module chunks = 0